import _map from 'lodash/map'

import SwiperCore, { Pagination, Navigation, Autoplay, EffectCoverflow } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import Styled from './styled'

SwiperCore.use([Pagination, Navigation, Autoplay, EffectCoverflow])

export default function Carousel({ innerRef, items = [], options = {}, uiRenderer = () => null }) {
  let swiperOptions = {
    slidesPerView: 1,
    navigation: false,
    pagination: {
      type: 'bullets',
      clickable: true,
    },
    ...options,
  }

  return (
    <Styled>
      <Swiper ref={innerRef} {...swiperOptions}>
        {_map(items, (item, index) => {
          return <SwiperSlide key={index}>{uiRenderer(item, index)}</SwiperSlide>
        })}
      </Swiper>
    </Styled>
  )
}
